import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const SectionTitle = styled.h5`
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.h5};
  margin-bottom: 24px;
  text-transform: capitalize;
`;

export const Section = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.innerProduct.lightGray};
  border-radius: 4px;
  padding: 28px 60px 76px 60px;
  margin-bottom: 40px;
  ${mq(1200)} {
    padding: 16px;
  }
`;
export const Title = styled.h6`
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.h6};
  margin-bottom: 8px;
  text-transform: capitalize;
`;
export const Description = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  margin-bottom: 26px;
  max-width: 680px;
  max-height: calc(16px * 1.5 * 5);
  overflow: hidden;
`;

export const Table = styled.table``;
export const Tr = styled.tr``;
export const TdGray = styled.td`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.lightPurple};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  padding-right: 20px;
  display: block;
  line-height: 20px;
  padding-bottom: 14px;
`;
export const Td = styled.td`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  line-height: 20px;
  padding-bottom: 14px;
`;

export const ShowMoreArrow = styled.div`
  max-width: 24px;
  min-width: 24px;
  max-height: 24px;
  min-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(90deg) scale(-1, 1) /*rtl: scale(1, -1) rotate(90deg)*/;
`;
export const ShowMore = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.cartCountColor};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 30px;
`;

export const Info = styled.p`
  position: relative;
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  padding-left: 22px;
  margin-bottom: 10px;
  &::before {
    position: absolute;
    content: '';
    left: 0;
    top: 8px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.auth.lightPurple};
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`;
